"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewAllBtn = exports.closeBtn = exports.cancelBtn = void 0;
var cancelBtn = {
  ml: 2
};
exports.cancelBtn = cancelBtn;
var closeBtn = {
  position: 'absolute',
  right: 30,
  top: 28
};
exports.closeBtn = closeBtn;
var viewAllBtn = {
  minWidth: 0,
  '.MuiButton-endIcon': {
    ml: 0,
    mr: 0
  }
};
exports.viewAllBtn = viewAllBtn;